import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../../shared/components/AppButton";
import styles from "../styles.module.css";

interface Props {
  spa: string;
  onClick: () => void;
  id: string;
}

export const LinkEditName: React.FC<Props> = ({ spa, id, onClick }) => {
  const { t } = useTranslation();

  const fullSpaName = spa ? spa.replace(/^spa-/, "").split(`-${id}`)[0] : "";
  const displayName =
    fullSpaName.length > 30
      ? fullSpaName.substring(0, 30) + "..."
      : fullSpaName;

  const displayLabel = spa
    ? `spa-${displayName}-${id}`
    : `spa-${t("editor.spa_name_placeholder")}-${id}`;

  return (
    <div className={styles["link-settings-container"]}>
      <div className={styles["link-settings"]}>
        <AppButton
          buttonType={"text"}
          onClick={onClick}
          className={styles["link"]}
        >
          {displayLabel}
        </AppButton>
      </div>
    </div>
  );
};
